<p-confirmDialog [style]="{ width: '450px' }"></p-confirmDialog>

<p-dialog
  [header]="dialogHeader"
  [(visible)]="showForm"
  [breakpoints]="{ '960px': '75vw' }"
  [style]="{ width: '90vw', height: '85vh', top: '1.5rem' }"
  [modal]="true"
  [draggable]="false"
  [resizable]="true"
  (onHide)="closeDialog()"
  [maximizable]="true"
>
  <div class="card" [formGroup]="validateForm">
    <div class="flex flex-column gap-3">
      
      <!-- Tipo de Competencia -->
      <div class="field">
        <label for="type">Tipo de Competencia</label>
        <p-selectButton
          [options]="competitionTypes"
          formControlName="type"
          optionLabel="label"
          optionValue="value"
          class="w-full"
        ></p-selectButton>
      </div>

      <!-- Nombre -->
      <div class="field">
        <label for="name">Nombre de la Competencia</label>
        <input
          type="text"
          pInputText
          placeholder="Ingrese nombre de la competencia"
          formControlName="name"
          class="w-full"
        />
      </div>

      <div class="grid">
        <!-- Fecha Inicio -->
        <div class="col-12 md:col-6">
          <div class="field">
            <label for="startDate">Fecha Inicio</label>
            <input
              type="date"
              pInputText
              placeholder="Fecha de inicio"
              formControlName="startDate"
              class="w-full"
            />
          </div>
        </div>

        <!-- Fecha Fin -->
        <div class="col-12 md:col-6">
          <div class="field">
            <label for="endDate">Fecha Fin</label>
            <input
              type="date"
              pInputText
              placeholder="Fecha de finalización"
              formControlName="endDate"
              class="w-full"
            />
          </div>
        </div>
      </div>

      <!-- Lugar -->
      <div class="field">
        <label for="location">Lugar</label>
        <input
          type="text"
          pInputText
          placeholder="Ingrese el lugar de la competencia"
          formControlName="location"
          class="w-full"
        />
      </div>

      <!-- Niveles de Competencia -->
      <div class="field">
        <label for="levels">Niveles de Competencia</label>
        <p-multiSelect
          display="chip"
          [showClear]="true"
          [maxSelectedLabels]="5"
          [options]="hockeyLevels"
          formControlName="levels"
          optionLabel="name"
          optionValue="id"
          placeholder="Seleccione los niveles para la competencia"
          (onChange)="onLevelSelected($event)"
          class="w-full"
        ></p-multiSelect>
        <small class="text-sm text-gray-600">Solo se muestran niveles asociados a Hockey</small>
      </div>

      <!-- Categorías -->
      <div class="field">
        <label for="categories">Categorías</label>
        <p-multiSelect
          display="chip"
          [showClear]="true"
          [maxSelectedLabels]="5"
          [options]="availableCategories"
          formControlName="categories"
          optionLabel="name"
          optionValue="id"
          placeholder="Seleccione categorías para la competencia"
          (onChange)="onCategorySelected($event)"
          class="w-full"
        ></p-multiSelect>
      </div>

      <!-- Fechas de Corte por Categoría -->
      <div class="field" *ngIf="categoriesWithCutoff.length > 0">
        <label>Fechas de Corte por Categoría</label>
        <div class="border-1 surface-border border-round p-3">
          <div 
            *ngFor="let item of categoriesWithCutoff; let i = index" 
            class="flex align-items-center gap-3 mb-2"
          >
            <div class="flex-1">
              <span class="font-medium">{{ item.category.name }}</span>
              <span class="text-sm text-gray-600 ml-2" *ngIf="item.category.branch">
                ({{ item.category.branch }})
              </span>
            </div>
            <input
              type="date"
              pInputText
              [value]="item.cutoffDate"
              (input)="updateCutoffDate(item.category.id, $any($event.target).value)"
              placeholder="Fecha de corte"
              class="w-auto"
              required
            />
          </div>
          <small class="text-sm text-gray-600">
            La fecha de corte se usa para calcular la edad de participación en cada categoría
          </small>
        </div>
      </div>

      <!-- URL Imagen -->
      <div class="field">
        <label for="urlImage">URL de Imagen (Opcional)</label>
        <input
          type="text"
          pInputText
          placeholder="Ingrese URL de la imagen de la competencia"
          formControlName="urlImage"
          class="w-full"
        />
        <small class="text-sm text-gray-600">Imagen representativa de la competencia</small>
      </div>

      <div class="grid">
        <!-- Pago Online Habilitado -->
        <div class="col-12 md:col-6">
          <div class="field">
            <label for="digitalPaymentAvailable">Pago Online Habilitado</label>
            <p-selectButton
              [options]="stateOptions"
              formControlName="digitalPaymentAvailable"
              optionLabel="label"
              optionValue="value"
              class="w-full"
            ></p-selectButton>
          </div>
        </div>

        <!-- Pago Manual Habilitado -->
        <div class="col-12 md:col-6">
          <div class="field">
            <label for="manualPaymentAvailable">Pago Manual Habilitado</label>
            <p-selectButton
              [options]="stateOptions"
              formControlName="manualPaymentAvailable"
              optionLabel="label"
              optionValue="value"
              class="w-full"
            ></p-selectButton>
          </div>
        </div>
      </div>

      <!-- Modelo de Pago -->
      <div class="field">
        <label for="paymentModel">Modelo de Cobro</label>
        <p-selectButton
          [options]="paymentModelOptions"
          formControlName="paymentModel"
          optionLabel="label"
          optionValue="value"
        ></p-selectButton>
        <small class="text-sm text-gray-600">
          {{ validateForm.get('paymentModel')?.value === 'PER_ATHLETE'
              ? 'La tarifa de inscripción se cobrará por cada atleta del equipo'
              : 'La tarifa de inscripción se cobrará una sola vez por equipo' }}
        </small>
      </div>

      <!-- Venta Cruzada -->
      <div class="field">
        <label for="hasCrosselling">Tiene Venta Cruzada</label>
        <p-selectButton
          [options]="stateOptions"
          formControlName="hasCrosselling"
          optionLabel="label"
          optionValue="value"
        ></p-selectButton>
      </div>

      <div *ngIf="validateForm.get('hasCrosselling')?.value" class="mt-3">
        <div class="flex justify-content-between align-items-center mb-2">
          <label class="font-semibold">Items de Venta Cruzada</label>
          <p-button label="Agregar Item" icon="pi pi-plus" size="small" (click)="addCrosselingItem()"></p-button>
        </div>

        <p-table [value]="crosselingItems" [tableStyle]="{'min-width': '50rem'}" *ngIf="crosselingItems.length > 0; else noCrosselingItems">
          <ng-template pTemplate="header">
            <tr>
              <th>Nombre</th>
              <th>Descripción</th>
              <th>Precio</th>
              <th>Alcance</th>
              <th>Acciones</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item let-i="rowIndex">
            <tr>
              <td>{{ item.name }}</td>
              <td>{{ item.description }}</td>
              <td>{{ item.amount | currency:'COP':'symbol':'1.0-0' }}</td>
              <td>{{ item.scope === 'PER_TEAM' ? 'Por Equipo' : 'Por Atleta' }}</td>
              <td>
                <p-button icon="pi pi-pencil" size="small" class="mr-2" (click)="editCrosselingItem(item, i)"></p-button>
                <p-button icon="pi pi-trash" severity="danger" size="small" (click)="deleteCrosselingItem(i)"></p-button>
              </td>
            </tr>
          </ng-template>
        </p-table>
        <ng-template #noCrosselingItems>
          <p class="text-center text-gray-500 py-3">No hay items de venta cruzada configurados</p>
        </ng-template>
      </div>

      <div class="grid">
        <!-- Disponible para Inscripción -->
        <div class="col-12 md:col-6">
          <div class="field">
            <label for="isOpenToRegister">Disponible para Inscripción</label>
            <p-selectButton
              [options]="stateOptions"
              formControlName="isOpenToRegister"
              optionLabel="label"
              optionValue="value"
              class="w-full"
            ></p-selectButton>
          </div>
        </div>

        <!-- Visible para Clubes -->
        <div class="col-12 md:col-6">
          <div class="field">
            <label for="isPublished">Visible para Clubes</label>
            <p-selectButton
              [options]="stateOptions"
              formControlName="isPublished"
              optionLabel="label"
              optionValue="value"
              class="w-full"
            ></p-selectButton>
          </div>
        </div>
      </div>

    </div>

    <!-- Botones de Acción -->
    <div class="flex mt-4 gap-2 justify-content-end">
      <p-button
        label="Cancelar"
        [outlined]="true"
        severity="secondary"
        [rounded]="true"
        (click)="closeDialog()"
      ></p-button>
      <p-button
        *ngIf="!isUpdateForm"
        type="submit"
        label="Guardar"
        [rounded]="true"
        [disabled]="validateForm.invalid"
        (click)="saveCompetition()"
      ></p-button>
      <p-button
        *ngIf="isUpdateForm"
        type="submit"
        label="Actualizar"
        [rounded]="true"
        [disabled]="validateForm.invalid"
        (click)="updateCompetition()"
      ></p-button>
    </div>
  </div>
</p-dialog>

<p-dialog
  [header]="editingIndex === -1 ? 'Nuevo Item de Venta Cruzada' : 'Editar Item de Venta Cruzada'"
  [(visible)]="showCrosselingDialog"
  [style]="{ width: '50vw' }"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  (onHide)="closeCrosselingDialog()"
>
  <div class="flex flex-column gap-3" *ngIf="editingCrosselingItem">
    <div class="flex flex-column gap-2">
      <label>Nombre *</label>
      <input type="text" pInputText placeholder="Nombre del item" [(ngModel)]="editingCrosselingItem.name" />
    </div>
    <div class="flex flex-column gap-2">
      <label>Descripción *</label>
      <textarea pInputTextarea rows="3" placeholder="Descripción" [(ngModel)]="editingCrosselingItem.description"></textarea>
    </div>
    <div class="flex flex-column gap-2">
      <label>Precio *</label>
      <p-inputNumber [(ngModel)]="editingCrosselingItem.amount" mode="currency" currency="COP" locale="es-CO" [min]="0"></p-inputNumber>
    </div>
    <div class="flex flex-column gap-2">
      <label>Alcance *</label>
      <p-selectButton [options]="scopeOptions" [(ngModel)]="editingCrosselingItem.scope" optionLabel="label" optionValue="value"></p-selectButton>
    </div>
    <div class="flex flex-column gap-2">
      <label>URL Imagen</label>
      <input type="text" pInputText placeholder="URL de la imagen" [(ngModel)]="editingCrosselingItem.urlImage" />
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="flex gap-2 justify-content-end">
      <p-button label="Cancelar" [outlined]="true" severity="secondary" (click)="closeCrosselingDialog()"></p-button>
      <p-button label="Guardar" [disabled]="!editingCrosselingItem?.name || !editingCrosselingItem?.description || !editingCrosselingItem?.amount" (click)="saveCrosselingItem()"></p-button>
    </div>
  </ng-template>
</p-dialog>